import React from "react";
import {Navbar, Nav, Button} from "react-bootstrap";
import logo22 from "../assets/logo22.png";
import classes from "../CSS/navbar.module.css";
import { NavLink} from "react-router-dom";

const CustomNavbar = ()=>{
    return(
        <>
        <div>
        <Navbar className="bg-transparent navbar-dark" className={classes.Navbar} expand="sm">
            <Navbar.Brand href="#home">
            {/* <span> <img style={{width:"200px",height:"100px",marginLeft:"20px"}} src={logo22} /> </span> */}
           <span style={{color:"white",fontWeight:"700",marginLeft:"20px"}}> S(HE)-Foundation</span>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ml-auto">
                <NavLink to="/"  className={classes.Link}><Nav  href="#home">Home</Nav></NavLink>
                <NavLink to="/about" activeClassName={classes.Selected}  className={classes.Link}><Nav href="#home">About</Nav></NavLink>
                <NavLink to="/blog" activeClassName={classes.Selected}  className={classes.Link}><Nav href="#home">Blog</Nav></NavLink>
                <NavLink to="/contact" activeClassName={classes.Selected}  className={classes.Link}><Nav href="#home">Contact</Nav></NavLink>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
        </div>
        </>
    )
}
export default CustomNavbar;